import Card from "../Card";

export default function IconCard({ children, className }) {
    return (
        <Card className={`flex flex-col items-center justify-center w-10 h-10 !rounded-md ${className}`}>
            {children}
        </Card>
    )
}